import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Training from './pages/Training';
import QAScorer from './pages/QAScorer';
import Dashboard from './pages/Dashboard';
import ImportHub from './pages/ImportHub';
import './App.css';

const AppLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-[#0d0f12]">
      <Sidebar />
      <main className="flex-1">
        {children}
      </main>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/training"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Training />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/qa"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <QAScorer />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/import"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <ImportHub />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
